export const EVENT_APP_DEF_ID = '140603ad-af8d-84a5-2c80-a0f60cb47351'
export const EVENTS_API_PATH_AMBASSADOR = '/_api/wix-events-web'
export const MAIN_FIELDS = ['firstName', 'lastName', 'email', 'rsvpStatus']
export const VALID_RSVP_STATUSES = ['YES', 'NO', 'WAITING']
